import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(weekday);
dayjs.extend(localeData);
export var HUMANIZE_FORMAT_12H = 'MM/DD/YYYY hh:mm A'; // 09/14/2021 12:49 pm
export var UNIX_TIMESTAMP_FORMAT = 'x'; // 1631598579000
export var DATE_FORMAT = 'MM-DD-YYYY'; // 06-26-1996
export var DATE_FORMAT_YMD = 'YYYY-MM-DD'; // 1996-06-26
export var DATE_FORMAT_MDY = 'LL'; // October 5, 2022
export var DATE_FORMAT_MONTH_YEAR = 'MMMM YYYY'; // June 2019
export var DATE_AND_TIME_FORMAT = 'L LT'; // 09/02/2021 12:22 AM
export var FIRST_DAY_DATE_FORMAT = 'dddd, L LT'; // Thursday, 09/02/2021 12:22 AM // Thursday, 09/02/2021 9:22 AM
export var TIME_FORMAT = 'LT'; // 12:22 AM
export var TIME_ZONE_FORMAT = 'LT Z'; // 12:22 AM -05:00
export var STANDARD_DATE_FORMAT = 'L'; // 09/02/2021
export var TIMEPICKER_FORMAT = 'hh:mm A'; // 12:45 PM
// antd v6 DatePicker/TimePicker format prop can't use localized formats like 'L', 'LT'
// Use these constants for antd component format props
export var DATEPICKER_FORMAT = 'MM/DD/YYYY'; // for antd DatePicker format prop
export var TIMEPICKER_ANTD_FORMAT = 'hh:mm A'; // for antd TimePicker format prop (same as TIMEPICKER_FORMAT but explicit)
export var DATETIME_PICKER_FORMAT = 'MM/DD/YYYY hh:mm A'; // for antd DatePicker showTime format
export var dateTimeFormat = function (datetime, format, UTC) {
    if (UTC === void 0) { UTC = false; }
    var dayjsDatetime = UTC ? dayjs.utc(datetime) : dayjs(datetime);
    var isValid = dayjsDatetime.isValid();
    if (!isValid || format === null)
        return typeof datetime === 'string' ? datetime : '';
    return dayjsDatetime.format(format);
};
// for the two-character array of hours or minutes
export var range = function (start, end) {
    var result = [];
    for (var i = start; i < end; i++) {
        result.push(i > 9 ? String(i) : "0".concat(i));
    }
    return result;
};
export var disabledBeforeDate = function (current) {
    return current && current < dayjs().startOf('day');
};
export var disabledAfterDate = function (current) {
    return current && current > dayjs().endOf('day');
};
export var getHumanizeTimeFormat12h = function (datetime) {
    return dateTimeFormat(datetime, HUMANIZE_FORMAT_12H);
};
export var humanizeDateString = function (dateString) { return dayjs.utc(dateString).local().format(HUMANIZE_FORMAT_12H); };
export var getUnixTimestampFormat = function (datetime) {
    return dateTimeFormat(datetime, UNIX_TIMESTAMP_FORMAT);
};
export var getDateFormat = function (date) { return dateTimeFormat(date, DATE_FORMAT); };
export var getDateFormatYMD = function (date) { return dateTimeFormat(date, DATE_FORMAT_YMD); };
export var getDateFormatMDY = function (date) { return dateTimeFormat(date, DATE_FORMAT_MDY); };
export var getDateFormatMonthYear = function (date) {
    return dateTimeFormat(date, DATE_FORMAT_MONTH_YEAR);
};
export var getDateAndTimeFormat = function (date) {
    return dateTimeFormat(date, DATE_AND_TIME_FORMAT);
};
export var getFirstDayDateFormat = function (date) {
    return dateTimeFormat(date, FIRST_DAY_DATE_FORMAT, true);
};
export var getFirstDayDateFormatIso = function (date) {
    return dateTimeFormat(date, FIRST_DAY_DATE_FORMAT);
};
export var getTimeFormat = function (date) { return dateTimeFormat(date, TIME_FORMAT); };
export var getTimeZoneFormat = function (date) { return dateTimeFormat(date, TIME_ZONE_FORMAT); };
export var getStandardDateFormat = function (date) {
    return dateTimeFormat(date, STANDARD_DATE_FORMAT);
};
export var getStandardUTCDateFormat = function (date) {
    return dateTimeFormat(date, STANDARD_DATE_FORMAT, true);
};
export var getTimeElapsedInHours = function (timestamp) {
    return (Date.now() - timestamp) / 1000 / 60 / 60;
};
export var getRelativeTime = function (date) { return dayjs(date).fromNow(); };
export var calculateAge = function (dob) {
    var birthDate = dayjs(dob, 'MM/DD/YYYY');
    var today = dayjs();
    return today.diff(birthDate, 'year');
};
export var convertSecondsToDuration = function (seconds) {
    if (!seconds)
        return null;
    var timeDuration = dayjs.duration(seconds, 'seconds');
    var hours = timeDuration.hours();
    var minutes = timeDuration.minutes();
    var secs = timeDuration.seconds();
    var result = '';
    if (hours > 0)
        result += "".concat(hours, "h ");
    if (minutes > 0)
        result += "".concat(minutes, "m ");
    if (secs > 0)
        result += "".concat(secs, "s");
    return result.trim();
};
export var calculateStateDuration = function (since) {
    return since ? Math.floor((Date.now() - since) / 1000) : 0;
};
